import { useSyncExternalStore } from 'react';
import { history } from '../utils/history';

const subscribe = (onChange: () => void) => history.listen(onChange);

/* Current pathname straight from the shared history singleton. Use this (not
   react-router's useLocation) in components that live outside the router
   outlets or inside the cached pathless tab route — Ionic's stack manager
   freezes closed-over values there, and the outlet renders routes with a
   synthesized location (see App.tsx / utils/history.ts). */
export const usePathname = (): string =>
  useSyncExternalStore(subscribe, () => history.location.pathname);
